import { PropsWithChildren, useEffect } from 'react';

import { PageLayout } from '@spotify/confidence-core-react';
import { PageImpression } from '@spotify/plugin-confidence-tracking-react';

import { useFavoritesCollection } from '../../hooks/useFavoritesCollection';
import { CollectionEntriesList } from '../CollectionPage/CollectionEntriesList';

// TODO: Move FavoritesPage to a dedicated plugin (e.g. confidence-favorites)
// so it can own its own route refs and plugin registration.
export const FavoritesPage = ({ children }: PropsWithChildren) => {
  const { favoritesCollectionName, ensureCollection } =
    useFavoritesCollection();

  useEffect(() => {
    ensureCollection();
  }, [ensureCollection]);

  return (
    <PageImpression pageId="favorites">
      <PageLayout
        enableMargin
        title="Favorites"
        isLoading={!favoritesCollectionName}
      >
        {favoritesCollectionName && (
          <CollectionEntriesList
            collectionName={favoritesCollectionName}
            isFavorites
          />
        )}
        {children}
      </PageLayout>
    </PageImpression>
  );
};
